<template>
  <div
    class="list"
    v-loading="loading"
    element-loading-text="数据获取中"
    v-if="listShow"
  >
    <div class="qmContent">
      <viewer :images="cutList" class="MQcut" v-if="cutList.length > 0">
        <img
          v-for="(img, index) in cutList"
          :key="index"
          class="uploadpic"
          :src="questionImgListUrl(img)"
          alt
        />
      </viewer>
      <div class="MQcut" v-else>
        <el-image class="uploadpic">
          <div slot="error" class="image-slot">
            <span>暂无截图</span>
          </div>
        </el-image>
      </div>
      <el-form
        ref="addForm"
        :model="qmData"
        label-position="top"
        size="mini"
        class="formList"
      >
        <el-form-item label="所属文件">
          <p :title="qmData.fileName" class="content contentMini">
            {{ qmData.fileName }}
          </p>
        </el-form-item>
        <el-form-item label="问题状态">
          <p class="content">{{ qmData.queStatus }}</p>
        </el-form-item>
        <el-form-item label="问题描述">
          <p :title="qmData.checkContent" class="content contentMini">
            {{ qmData.checkContent }}
          </p>
        </el-form-item>
        <el-form-item label="审图要点">
          <p :title="qmData.drawingReviewPoints" class="content contentMini">
            {{ qmData.drawingReviewPoints || " " }}
          </p>
        </el-form-item>
        <el-form-item label="关联文件" class="associatedFileStyle">
          <ul>
            <li v-for="(item, index) in qmData.annexFileList" :key="index">
              <p class="fileNamestyle" :title="item.fileName">
                {{ item.fileName }}
              </p>
              <p style="margin-top: 3px">
                <img
                  :src="down"
                  alt="下载"
                  style="margin-right: 15px; cursor: pointer"
                  @click="todown(item)"
                />
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="意见类型">
          <p class="content">{{ qmData.qmType }}</p>
        </el-form-item>
        <el-form-item label="严重等级">
          <p class="content">{{ qmData.problemType }}</p>
        </el-form-item>
        <!-- <el-form-item label="阶段" v-if="stageNameBoolean">
          <p class="content"> {{stageName}} </p>
        </el-form-item> -->
        <!-- <el-form-item label="专业">
          <p class="content">{{ qmData.specName }}</p>
        </el-form-item> -->
        <el-form-item label="专业">
          <p class="content">{{ multiSpecName }}</p>
        </el-form-item>
        <!-- <el-form-item label="子项" v-if="childNameBoolean">
          <p class="content"> {{childName}} </p>
        </el-form-item> -->
        <el-form-item label="修改方">
          <p class="content">{{ modifierName }}</p>
        </el-form-item>
        <el-form-item label="创建人">
          <p class="content">{{ qmData.creatorName }}</p>
        </el-form-item>
        <el-form-item label="创建时间">
          <p class="content">{{ qmData.createDate }}</p>
        </el-form-item>
        <el-form-item label="问题来源">
          <p class="content">{{ qmData.source }}</p>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="editForm">修 改</el-button>
    </div>
  </div>
</template>

<script>
import notationService from "@/CommonDP/service/file-service";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
import { questionImgUrl1, downloadUrltoken } from "@/utils";
import { mapState } from "vuex";
export default {
  props: ["questionId", "type"],
  data() {
    return {
      qmData: {},
      cutList: [],
      loading: false,
      prjId: "",
      listShow: false,

      stageName: "",
      stageNameBoolean: false,
      specName: "",
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: "",
      childNameBoolean: false,
      modifierName: "",
      down: require("@/CommonDP/assets/issueMgDown.png"),
    };
  },
  computed: {
    ...mapState({
      spaceOfDwgData: (state) => state.monge.spaceOfDwgData,
      hasDwg: (state) => state.monge.hasDwg,
    }),
  },
  methods: {
    show() {
      this.listShow = false;
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        const res = await notationService.getDrawingQuestionDetails(
          this.questionId
        );
        this.qmData = res.data;
        this.$parent.rowData = res.data;
        if (res.data.modelPageFileName) {
          this.$store.dispatch("setHasDwg", true);
        } else {
          this.$store.dispatch("setHasDwg", false);
        }
        this.$store.dispatch("setModelquestionData", res.data);
        let names = [];
        let multiSpecName = [];
        this.qmData.modifierList.forEach((element) => {
          names.push(element.modifierName);
        });
        this.modifierName = names.join(",");

        this.multiSpecName = this.qmData.multiSpecList.forEach((element) => {
          multiSpecName.push(element.specName);
        });
        this.multiSpecName = multiSpecName.join(",");
        this.prjId = this.qmData.prjId;
        if (!!this.qmData.autoScreenshotMd5) {
          this.cutList = [
            this.qmData.autoScreenshotMd5,
            ...this.qmData.picMd5List,
          ];
        } else {
          this.cutList = [...this.qmData.picMd5List];
        }

        this.listShow = true;
        this.loading = false;
        this.$nextTick(async () => {
          if (this.$route.query.questionId || this.questionId) {
            await this.showSomething();
          }
        });
      } catch (error) {
        this.loading = false;
      }
    },
    async showSomething() {
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
        if (this.qmData.layoutName !== JSON.parse(this.spaceOfDwgData)) {
          this.$store.dispatch("setAnnotationData", this.qmData);
          this.$store.dispatch(
            "setSpaceOfDwgData",
            JSON.stringify(this.qmData.layoutName)
          );
        } else {
          this.$store.dispatch("setAnnotationData", this.qmData);
          let color = "";
          switch (this.qmData.queStatus) {
            case "待修改":
              color = Number("0xEB5757");
              break;
            case "已修改":
              color = Number("0x27AE60");
              break;
            case "已复核":
              color = Number("0x4B6A8F");
              break;
            case "无效":
              color = Number("0x8B8888");
              break;
          }
          const data =
            this.qmData.source === "WEB端"
              ? JSON.parse(this.qmData.coordinate)
              : JSON.parse(this.qmData.anchorPoint);
          if (!!data) {
            data.stMarkNewInfo.color = color;
            Monge.Map.Annotation.add({
              data,
              callback: (type, data) => {
                if (type === Monge.CallbackType.DONE) {
                  Monge.Map.Annotation.fitTo({ id: data.id });
                }
              },
            });
          }
        }
      } else if (this.type == "rvt") {
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        } else {
          Monge.Model.Mark.clear();
          Monge.Model.Mark.deactive();
        }
        let color = "";
        switch (this.qmData.queStatus) {
          case "待修改":
            color = Number("0xEB5757");
            break;
          case "已修改":
            color = Number("0x27AE60");
            break;
          case "已复核":
            color = Number("0x4B6A8F");
            break;
          case "无效":
            color = Number("0x8B8888");
            break;
        }
        let data = JSON.parse(this.qmData.coordinate);
        data.color = color;
        await this.$nextTick();
        if (!this.hasDwg) {
          Monge.Model.Mark.add(data);
          Monge.Model.Camera.setViewport(
            JSON.parse(this.qmData.viewPoint || "")
          );
        } else {
          Monge.Map.Annotation.add({
            data,
            callback: (type, data) => {
              if (type === Monge.CallbackType.DONE) {
                Monge.Map.Annotation.fitTo({ id: data.id });
              }
            },
          });
        }
      }
    },
    questionImgListUrl(fileMD5) {
      if (!fileMD5) {
        return;
      }
      return questionImgUrl1(fileMD5);
    },
    editForm() {
      this.$emit("openEdit");
    },
    todown(row) {
      const prjId = this.$route.query.prjId;
      const fileId = row.fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = fileUrl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  // height: 100%;
  padding: 10px 0 10px 10px;
  .qmContent {
    width: 100%;
    height: calc(100% - 50px);
    padding-right: 10px;
    overflow-y: auto;
    /deep/.el-form-item__label {
      font-size: 14px;
      line-height: 22px;
      color: #666666;
      user-select: none;
    }
    /deep/.el-form-item__content {
      background: rgba(179, 201, 253, 0.12);
    }
    .content {
      padding: 5px 0 5px 5px;
      user-select: none;
      width: 100%;
      font-size: 14px;
      line-height: 30px;
      max-height: 85px;
      min-height: 40px;
      color: #323232;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .contentMini {
      font-size: 14px;
      line-height: 20px;
      color: #58667b;
    }
    .associatedFileStyle {
      li {
        display: flex;
        justify-content: space-between;
        color: #3873fe;
        user-select: none;
      }
      .fileNamestyle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 330px;
        padding-left: 5px;
      }
      li:hover {
        background: #eef1ff;
      }
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    .el-button {
      width: 90%;
      height: 100%;
    }
  }
  .MQcut {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic {
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
      /deep/.image-slot {
        width: 75px;
        height: 75px;
        line-height: 75px;
        background: rgb(239, 239, 239);
        color: rgb(153, 153, 153);
        text-align: center;
      }
    }
  }
  .formList {
    width: 100%;
    height: calc(100% - 80px);
  }
}
</style>